import { DownloadDocument } from '../../../utils/statApi/DocumentApi';
import config from '../ConfigLoader';

const viewableFileMimeTypes: Record<string, string> = {
  txt: 'text/plain',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
};

function convertBlobToUrl(blob: Blob): string {
  return window.URL.createObjectURL(blob);
}

export function openBlobInNewTab(blob: Blob, fileName?: string): void {
  const file: File = new File([blob], fileName, { type: blob.type });
  const url = window.URL.createObjectURL(file);

  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = fileName;
  anchor.click();

  window.URL.revokeObjectURL(url);
}

export const downloadBlob = async (
  documentId: number,
  fileName: string,
  onError: (errorMessage?: string) => void,
): Promise<void> => {
  const blob = await DownloadDocument(documentId, onError);

  if (blob) {
    openBlobInNewTab(blob, fileName);
  }
};

export const openBlob = async (
  documentId: number,
  fileName: string,
  onError: (errorMessage?: string) => void,
): Promise<void> => {
  const extension = fileName.split('.').pop()?.toLowerCase();
  const viewableExtensions = new RegExp(config?.settings?.viewableExtensionsRegex, 'i');

  if (!extension || !viewableExtensions.test(extension) || !viewableFileMimeTypes[extension]) {
    await downloadBlob(documentId, fileName, onError);
  } else {
    const blob = await DownloadDocument(documentId, onError);
    if (!blob) {
      return;
    }
    const safeBlob = new Blob([blob], { type: viewableFileMimeTypes[extension] });
    const blobUrl = convertBlobToUrl(safeBlob);

    window.open(blobUrl);
  }
};
